import request from '@/utils/request'

// 日志

let LogApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/log.log/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/log.log/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/log.log/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/log.log/edit', data, errorback);
    }
}

export default LogApi;



// WEBPACK FOOTER //
// ./src/api/log.js